/**
 * Волна C (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute path='/delivery/:id'>.
 */
import { createFileRoute, notFound, redirect } from '@tanstack/react-router';
import CacheDataRoute from '../../CacheDataRoute';
import AreaPage from '@routes/Area';
import { getQueryClient } from '../../providers/query';
import { rangeByIdQueryOptions } from '@queries/index';
import { isContentNotFoundError } from '../../api/contentNotFound';

export const Route = createFileRoute('/delivery/$id')({
  /**
   * ЭТАП 2 — два серверных сценария вместо клиентских редиректов:
   *
   * 1) Регистр в адресе. Компонент рендерил <Redirect> на lowercase уже
   *    после монтирования (пустая страница + прыжок). Теперь сервер отдаёт
   *    честный 301 — и поисковику, и пользователю.
   * 2) Несуществующая зона. Бэк (range.resolver) кидает CONTENT_NOT_FOUND ->
   *    notFound() -> HTTP 404 + контент /404 без редиректа; раньше это был
   *    клиентский history.push('/404').
   *
   * Лоадеры TanStack параллельны root-префетчу -> await ensureQueryData
   * (дедуп по ключу; у rangeById уже стоит retry:false). Клиентскую
   * навигацию не блокируем — там остаётся прежнее поведение компонента.
   */
  loader: async ({ params, location }) => {
    const lowercasePath = location.pathname.toLowerCase();
    if (location.pathname !== lowercasePath) {
      throw redirect({ to: lowercasePath, statusCode: 301 });
    }
    if (typeof window !== 'undefined') {
      return;
    }
    const queryClient = getQueryClient();
    const options = rangeByIdQueryOptions(decodeURIComponent(params.id));
    // Префетч успел упасть раньше — ошибка уже в кэше, без второго запроса
    const settled = queryClient.getQueryState(options.queryKey);
    if (settled?.error) {
      if (isContentNotFoundError(settled.error)) {
        throw notFound();
      }
      return;
    }
    try {
      await queryClient.ensureQueryData(options);
    } catch (error) {
      if (isContentNotFoundError(error)) {
        throw notFound();
      }
    }
  },
  component: () => <CacheDataRoute component={AreaPage} path='/delivery/:id' />
});
